import { LocationNode } from '../location';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ResponseTranslation } from '../translation/Translations';

export enum InventorySessionStatus {
  Open = 0,
  Closed = 1,
}

export enum InventorySessionType {
  Parent = 0,
  Child = 1,
}

export interface InventorySession {
  id: string;
  number: string;
  name?: string;
  locationCode: string;
  location?: LocationNode;
  status: InventorySessionStatus;
  type: InventorySessionType;
  parentSessionId?: string;
  scannedCount: number;
  children?: InventorySession[];
  totalChildScannedCount: number;
  createdAt: string;
  createdByUserId: string;
  createdByUserName: string;
}

export interface InventorySessionScan {
  id: string;
  sessionId: string;
  lotItemNumber: string;
  scannedAt: string;
  locationCodeAtScan: string;
  insideLocation: boolean;
  scannedByUserName: string;
}

export interface CreateInventorySessionRequest {
  locationCode: string;
  name?: string;
}

export interface CreateChildInventorySessionRequest {
  locationCode: string;
}

export interface InventorySessionSearchCommand {
  number?: string;
  locationCode?: string;
  statuses?: InventorySessionStatus[];
  type?: InventorySessionType;
  parentSessionId?: string;
}

export interface InventorySessionSearchResult {
  items: InventorySession[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
}

export interface InventorySessionScanSearchResult {
  items: InventorySessionScan[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
}
